import { createSelector } from 'reselect';
import { initialState } from './reducer';

const SCOPE = 'printerProfiles';

const selectDomain = state => state[SCOPE] || initialState;

export const makeSelectProperty = key =>
  createSelector(selectDomain, substate => substate[key]);
